"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tomTomLatLonStringSchema = exports.tomTomReverseGeocodeResponseSchema = exports.tomTomFuzzySearchResponseSchema = void 0;
const zod_1 = require("zod");
// TomTom Search API v2 — only the fields the address lookup reads. Unknown keys are stripped.
// https://docs.tomtom.com/search-api/documentation/search-service/fuzzy-search
const tomTomAddressSchema = zod_1.z.object({ freeformAddress: zod_1.z.string() });
const tomTomPositionSchema = zod_1.z.object({
    lat: zod_1.z.number().min(-90).max(90),
    lon: zod_1.z.number().min(-180).max(180),
});
exports.tomTomFuzzySearchResponseSchema = zod_1.z.object({
    results: zod_1.z.array(zod_1.z.object({
        address: tomTomAddressSchema,
        position: tomTomPositionSchema,
    })),
});
/** Reverse geocoding lists `addresses` (not `results`) and gives `position` as a "lat,lon" string. */
exports.tomTomReverseGeocodeResponseSchema = zod_1.z.object({
    addresses: zod_1.z.array(zod_1.z.object({
        address: tomTomAddressSchema,
        position: zod_1.z.string(),
    })),
});
exports.tomTomLatLonStringSchema = zod_1.z
    .string()
    .regex(/^-?\d+(\.\d+)?,-?\d+(\.\d+)?$/)
    .transform((value) => {
    const [lat, lon] = value.split(',').map(Number);
    return { lat, lon };
})
    .pipe(tomTomPositionSchema);
//# sourceMappingURL=tomtomSearch.js.map